<section class="dsp-terms-of-use">
  <dsp-header></dsp-header>
  <div class="dsp-terms-of-use-content">
    <div class="row">
      <div class="columns">
        <div class="dsp-terms-of-use-header terms-of-use">
          <div></div>
          <h4>Terms & Conditions</h4>

          <atlas-icon class="dsp-print-icon" (click)="termsAndConditions('termsAndConditionDivId')" icon="print"
            [size]="'large'" collection="technology-solid">
          </atlas-icon>
        </div>

        <div class="dsp-terms-of-use-scroll" id="termsAndConditionDivId" [innerHTML]="terms$ | async"></div>
      </div>
    </div>
  </div>
  <dsp-footer></dsp-footer>
</section>